/*
 * PAWS & PEARLS · THE MUSE · IVORY DEPARTURE / BUTTERFLY ESCORT · TEST V1
 * 30 October 2026. Additive Secret Sky scene behaviour; no existing assets overwritten.
 *
 * Before launch: the original V18 balloon stage has an ivory background;
 * five tiny, approved pearl-and-rose-gold butterflies flutter around the balloon.
 * At a genuine V18 balloon activation: butterflies accompany the four existing
 * balloons and The Muse upward. They leave before the night-sky episode.
 * When the existing night begins (or the V18 return descent starts), the stage
 * transitions to its ORIGINAL #111 black and remains black after landing.
 *
 * Does not alter V18 flight, camera Tests A/C, companion balloons, music,
 * original nightfall fireflies, pearls or document scroll. Returning fireflies
 * are intentionally NOT part of this first test.
 */
(function () {
  'use strict';
  var script = document.currentScript;
  var RAW = script && script.getAttribute('data-pp-sky-butterfly-frames');
  var URLS = RAW ? RAW.split('|').map(function (x) { return x.trim(); }).filter(Boolean) : [];
  if (URLS.length !== 8) {
    console.warn('[P&P Ivory Departure] Eight butterfly-frame URLs must be supplied in the script tag.');
    return;
  }
  var STAGE_ID = 'pp-muse-balloon-stage';
  var STYLE_ID = 'pp-muse-ivory-butterfly-departure-style-v1';
  var DEPLOYED = new WeakSet();
  var EXPECTED_FLIGHT_MS = 39000;
  var NIGHT_FALLBACK_AT_MS = 23900; // start of V18's return, after the extended sky hold
  var ASCENT_ESCORT_MS = 15000;    // includes the existing 4-second companion prelude
  var ESCORT_FADE_START_MS = 11800;
  var FRAME_MS = 100;
  var CLASS = 'pp-muse-departure-butterfly-v1';
  // Fractions of the stage rectangle: a restrained, asymmetrical little colony.
  var SPECS = [
    {x: .17, y: .32, size: .066, phase: .9,  angle: -9,  orbitX: 9, orbitY: 7},
    {x: .30, y: .70, size: .055, phase: 2.4, angle: 8,   orbitX: 7, orbitY: 11},
    {x: .70, y: .27, size: .061, phase: 4.6, angle: 12,  orbitX: 11,orbitY: 6},
    {x: .83, y: .61, size: .067, phase: 1.3, angle: -12, orbitX: 8, orbitY: 10},
    {x: .54, y: .79, size: .048, phase: 3.7, angle: 6,   orbitX: 10,orbitY: 8}
  ];
  function clamp(x, min, max) { return Math.min(max, Math.max(min, x)); }
  function ease(x) { x = clamp(x, 0, 1); return x * x * (3 - 2 * x); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function matchesMusePage() {
    return document.documentElement.classList.contains('pp-muse-secret-sky-page') &&
      !!document.getElementById('pp-muse-secret-sky');
  }
  function installStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var css = document.createElement('style');
    css.id = STYLE_ID;
    css.textContent = [
      '#'+STAGE_ID+'{background-color:#f7f4ed!important;}',
      '#'+STAGE_ID+'.pp-muse-ivory-ready-v1{transition:background-color 3.5s ease-in-out!important;}',
      '#'+STAGE_ID+'.pp-muse-landing-night-v1{background-color:#111111!important;}',
      '#'+STAGE_ID+' .pp-muse-day-butterfly-bed-v1{position:absolute!important;inset:0!important;z-index:2!important;pointer-events:none!important;overflow:hidden!important;contain:paint!important;}',
      '.'+CLASS+'{position:absolute;display:block;left:0;top:0;width:var(--pp-bfly-size);height:auto;max-width:none!important;pointer-events:none!important;user-select:none!important;-webkit-user-drag:none;transform-origin:center center;will-change:transform,opacity;}',
      '.'+CLASS+'.pp-muse-bfly-escort-v1{position:fixed!important;left:0!important;top:0!important;z-index:2147482997!important;max-width:none!important;pointer-events:none!important;}',
      '@media(prefers-reduced-motion:reduce){#'+STAGE_ID+'{transition:none!important;}.'+CLASS+'{will-change:auto!important;}}'
    ].join('\n');
    document.head.appendChild(css);
  }
  function findFlight(button) {
    if (!button || typeof button.getAnimations !== 'function') return null;
    try {
      return button.getAnimations().find(function (a) {
        return a.effect && a.effect.getTiming &&
          Math.abs(Number(a.effect.getTiming().duration) - EXPECTED_FLIGHT_MS) < 1 &&
          a.playState !== 'finished' && a.playState !== 'idle';
      }) || null;
    } catch (e) { return null; }
  }
  function install(stage) {
    if (DEPLOYED.has(stage) || !matchesMusePage()) return;
    var balloon = stage.querySelector('button.pp-balloon');
    if (!balloon) return;
    DEPLOYED.add(stage);
    installStyle();
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var bed = document.createElement('div');
    bed.className = 'pp-muse-day-butterfly-bed-v1';
    bed.setAttribute('aria-hidden', 'true');
    stage.appendChild(bed);
    var butterflies = [];
    SPECS.forEach(function (spec, i) {
      var img = document.createElement('img');
      img.className = CLASS;
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.draggable = false;
      img.decoding = 'async';
      img.src = URLS[i % 8];
      bed.appendChild(img);
      butterflies.push({el: img, spec: spec, frame: -1, start: null, size: 0});
    });
    // Only show loaded frames; never replace an approved visual with a lookalike.
    var framesReady = [false,false,false,false,false,false,false,false];
    URLS.forEach(function (url, i) {
      var im = new Image();
      im.onload = function () { framesReady[i] = true; };
      im.onerror = function () { framesReady[i] = false; };
      im.src = url;
      if (im.complete && im.naturalWidth > 0) framesReady[i] = true;
    });
    var mode = 'ivory'; // ivory → escort → night-return; never resets within one page visit
    var flight = null;
    var raf = 0;
    var startMs = 0;
    var lastSpriteMs = 0;
    var disposed = false;
    var flightStarted = false;
    var butterfliesRetired = false;
    function colorNight() {
      if (mode !== 'night-return') {
        mode = 'night-return';
        stage.classList.add('pp-muse-landing-night-v1');
      }
    }
    function retireButterflies() {
      if (butterfliesRetired) return;
      butterfliesRetired = true;
      butterflies.forEach(function (b) { if (b.el.isConnected) b.el.remove(); });
      if (bed.isConnected) bed.remove();
    }
    function finish() {
      colorNight();
      retireButterflies();
      if (raf) cancelAnimationFrame(raf);
      raf = 0;
    }
    function paintFrame(b, frameIndex) {
      if (frameIndex === b.frame || !framesReady[frameIndex]) return;
      b.el.src = URLS[frameIndex];
      b.frame = frameIndex;
    }
    function drawIvory(now) {
      var rect = stage.getBoundingClientRect();
      butterflies.forEach(function (b, i) {
        var c = b.spec;
        var size = clamp(rect.width * c.size, 19, 61);
        b.size = size;
        b.el.style.setProperty('--pp-bfly-size', size.toFixed(1) + 'px');
        var t = now / 1000;
        var dx = Math.sin(t * .91 + c.phase) * c.orbitX;
        var dy = Math.cos(t * .72 + c.phase) * c.orbitY;
        var x = rect.width * c.x + dx - size * .5;
        var y = rect.height * c.y + dy - size * .5;
        b.el.style.transform = 'translate3d('+x.toFixed(1)+'px,'+y.toFixed(1)+'px,0) rotate('+(c.angle + 6*Math.sin(t*.67+c.phase)).toFixed(1)+'deg)';
        b.el.style.opacity = '0.88';
        paintFrame(b, Math.floor((now + i * 115) / FRAME_MS) % URLS.length);
      });
    }
    function prepareFlight() {
      butterflies.forEach(function (b, i) {
        var r = b.el.getBoundingClientRect();
        b.start = {x: r.left, y: r.top};
        b.el.classList.add('pp-muse-bfly-escort-v1');
        document.body.appendChild(b.el);
        b.el.style.transform = 'translate3d('+r.left.toFixed(1)+'px,'+r.top.toFixed(1)+'px,0)';
      });
      if (bed.isConnected) bed.remove();
    }
    function nightIsBeginning() {
      try {
        var api = window.ppMuseEnchantedNightV1;
        var st = api && api.getStatus && api.getStatus();
        return !!(st && (st.phase === 'dusk' || st.phase === 'enchanted-night'));
      } catch (e) { return false; }
    }
    function drawEscort(now) {
      var elapsed = Math.max(0, now - startMs);
      var balloonRect = balloon.getBoundingClientRect();
      // Keep the escort within the same visual reference as the V18 balloon.
      // Its mobile camera may follow scroll; butterflies never add page height.
      butterflies.forEach(function (b, i) {
        var s = b.spec;
        var size = b.size;
        var u = ease(Math.min(1, elapsed / (2100 + i*120)));
        var t = elapsed / 1000;
        var cx = balloonRect.left + balloonRect.width/2;
        var cy = balloonRect.top + balloonRect.height * .42;
        var ring = [
          [-.62,-.18],[.57,.03],[-.46,.43],[.63,-.35],[0,-.62]
        ][i];
        var tx = cx + ring[0] * balloonRect.width * .80 - size*.5 + Math.sin(t*1.17+s.phase)*8;
        var ty = cy + ring[1] * balloonRect.height * .72 - size*.5 + Math.cos(t*.98+s.phase)*10;
        // The original scattered butterflies gather around the balloon,
        // then rise with it: never steal control of the Muse's flight.
        var x = lerp(b.start.x, tx, u);
        var y = lerp(b.start.y, ty, u);
        var twist = s.angle + Math.sin(t*1.8+s.phase)*10;
        b.el.style.transform = 'translate3d('+x.toFixed(1)+'px,'+y.toFixed(1)+'px,0) rotate('+twist.toFixed(1)+'deg)';
        var fade = 1 - ease((elapsed - ESCORT_FADE_START_MS)/(ASCENT_ESCORT_MS - ESCORT_FADE_START_MS));
        b.el.style.opacity = (Math.max(0, .88*fade)).toFixed(3);
        paintFrame(b, Math.floor((now + i * 115) / FRAME_MS) % URLS.length);
      });
      if (elapsed >= ASCENT_ESCORT_MS) retireButterflies();
    }
    function tick(now) {
      raf = 0;
      if (disposed || !stage.isConnected || !balloon.isConnected) { cleanup(); return; }
      if (document.hidden) { raf = requestAnimationFrame(tick); return; }
      if (!reduced && mode === 'ivory' && now - lastSpriteMs >= 70) {
        lastSpriteMs = now;
        // Avoid repainting off-screen idle butterflies while a visitor explores.
        var sr = stage.getBoundingClientRect();
        if (sr.bottom >= -30 && sr.top <= window.innerHeight + 30) drawIvory(now);
      }
      if (mode === 'escort' || flightStarted) {
        if (mode === 'escort' && !butterfliesRetired) drawEscort(now);
        var flightTime = flight ? Number(flight.currentTime) : 0;
        if (nightIsBeginning() || (isFinite(flightTime) && flightTime >= NIGHT_FALLBACK_AT_MS)) colorNight();
      }
      // Night color must survive the rest of the visit. Continue monitoring
      // only until the original V18 landing promise has finished.
      if (flightStarted && flight && flight.playState === 'finished') { finish(); return; }
      raf = requestAnimationFrame(tick);
    }
    function onBalloonClick() {
      if (flightStarted || disposed || reduced) return;
      // Earlier V18 click handler has already detached the original balloon.
      if (!balloon.classList.contains('pp-muse-flight-overlay')) return;
      var verified = findFlight(balloon);
      if (!verified) return;
      flight = verified;
      flightStarted = true;
      mode = 'escort';
      startMs = performance.now();
      prepareFlight();
      // The original V18 completion controls landing/pearls; never interfere.
      var token = flight;
      if (token.finished && typeof token.finished.then === 'function') {
        token.finished.then(function () {
          if (!disposed && flight === token) finish();
        }).catch(function () { /* Original controller handles cancellations. */ });
      }
    }
    function cleanup() {
      if (disposed) return;
      disposed = true;
      if (raf) cancelAnimationFrame(raf);
      raf = 0;
      balloon.removeEventListener('click', onBalloonClick);
      document.removeEventListener('shopify:section:unload', onUnload);
      retireButterflies();
      DEPLOYED.delete(stage);
    }
    function onUnload(event) { if (event.target && event.target.contains(stage)) cleanup(); }
    balloon.addEventListener('click', onBalloonClick);
    document.addEventListener('shopify:section:unload', onUnload);
    // Reduced-motion visitors see the same ivory → black narrative as a
    // static state when an actual V18 flight is available; no flight/animations
    // are forced if the core V18 declines launch.
    if (reduced) {
      butterflies.forEach(function (b,i) {
        if (i > 2) b.el.style.display = 'none';
        else { b.el.src = URLS[0]; b.el.style.opacity='.85'; }
      });
      drawIvory(performance.now());
    } else {
      raf = requestAnimationFrame(tick);
    }
    // Only turn on the colour transition AFTER applying the initial ivory,
    // otherwise the first page paint would awkwardly fade from old black.
    requestAnimationFrame(function () {
      if (stage.isConnected) stage.classList.add('pp-muse-ivory-ready-v1');
    });
    window.ppMuseIvoryButterflyDepartureV1 = {
      version: '1.0-test',
      getStatus: function () {
        return {mode:mode,flightStarted:flightStarted,balloonFlightMs:flight ? Math.round(Number(flight.currentTime)||0) : null,
          butterfliesPresent:butterflies.filter(function(b){return b.el.isConnected;}).length,
          originalNightFirefliesUntouched:true,soundUntouched:true};
      }
    };
  }
  function boot() {
    if (!matchesMusePage()) return;
    var stage = document.getElementById(STAGE_ID);
    if (stage) install(stage);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
